import React, {Component} from 'react';
import { PageHeader, Form, Input, Button, Modal} from 'antd';
import {UserOutlined, LockOutlined} from '@ant-design/icons';
import {Store} from "rc-field-form/lib/interface";
import { State } from './reducer';
import { Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { SWITCH_MENU_STATE } from './actions';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';

const mapStateToProps = (state: State) => {
    return {

    }
}
  
const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        switchToHome: () => dispatch({type: SWITCH_MENU_STATE, newState: "home"})
    }
}
  
const connector = connect(mapStateToProps, mapDispatchToProps);

interface LoginState {
    loading: boolean,
    showPassword: boolean,
    internalEmail: string | null
}

class Login extends Component<RouteComponentProps & ConnectedProps<typeof connector> >
{
    state: LoginState = {
        loading: false,
        showPassword: false,
        internalEmail: null
    }

    showError = (msg: string) => {
        Modal.info(
        {
            title: "Error during login",
            content: (
                <p>{msg}</p>
            ),
            onOk: () => {}
        });
    }

    handleSubmit = async (values: Store) =>
    {
        const email = String(values["email"] || "").trim().toLowerCase();

        if(email.length===0) {
            this.showError("Please input your e-mail!");
            return;
        }

        const needLoginTypeCheck = !this.state.showPassword || this.state.internalEmail !== email;

        if(needLoginTypeCheck)
        {
            let loginTypeData: any;

            const loginTypeDataForm = new FormData();
            loginTypeDataForm.append("email", email);

            this.setState({loading: true});
            try {
                const loginTypeResp = await fetch("/api/login_type",
                    {method: "POST",
                        body: loginTypeDataForm});
                loginTypeData = await loginTypeResp.json();
            } catch(error) {
                loginTypeData = {"err": "Connection issue with service"};
            }
            this.setState({loading: false});

            if("err" in loginTypeData)
            {
                this.showError(loginTypeData.err);
                return;
            }

            if(loginTypeData.login_type !== "internal")
            {
                const keycloakUrl = loginTypeData.keycloak_auth_url

                if(keycloakUrl.length===0)
                {
                    this.showError("Invalid external login configuration");
                    return;
                }

                window.location.href = keycloakUrl;
                return;
            }

            this.setState({showPassword: true, internalEmail: email});
        }

        const password = String(values["password"] || "");
        if(password.length===0)
        {
            return;
        }

        var formData = new FormData();
        formData.append("email", email);
        formData.append("password", password)
        
        this.setState({loading: true})
        let jdata: any;
        try {
            const resp = await fetch("/api/login",
                {method: "POST",
                    body: formData});

            jdata = await resp.json();
        } catch(error) {
            jdata = {"err": "Connection issue with service"};
        }

        this.setState({loading: false})
        if("err" in jdata)
        {
            this.showError(jdata.err);
            return;
        }

        this.props.switchToHome();
        this.props.history.push("/app/home");
        console.log(jdata);
    }

    render() {
        const loginForm = (
        <Form onFinish={this.handleSubmit} className="login-form">
            <Form.Item rules={[{ required: true, message: 'Please input your e-mail!' }]} name="email">
                <Input
                prefix={<UserOutlined />}
                disabled={this.state.showPassword || this.state.loading}
                placeholder="E-mail"/>
            </Form.Item>
            {this.state.showPassword &&
            <Form.Item rules={[{ required: true, message: 'Please input your password!' }]} name="password">
                <Input
                prefix={<LockOutlined />}
                disabled={this.state.loading}
                type="password"
                placeholder="Password"/>
            </Form.Item>}
            <Link to="/app/forgot_pw">Forgot password</Link>
                        
            <hr style={{visibility: "hidden"}}></hr>
            <Form.Item>
                <Button type="primary" htmlType="submit" className="login-form-button" loading={this.state.loading}>
                {!this.state.showPassword && "Continue"}
                {this.state.showPassword && "Log in"}
                </Button>
            </Form.Item>
        </Form>
        );

        return (
            <div style={{ height: "100%"}}>
                <PageHeader title="Login" />
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "80%" }}>
                    <div>
                    {loginForm}
                    </div>
                </div>
            </div>
        )
    }

    /*async componentDidMount() {
        await this.handleSubmit({"email": "martin@urbackup.org", "password": "saa7134_b"});
    }*/
}

export default withRouter(connector(Login))